import { reactive } from "vue"

export const hierarquia_GEOF = reactive([
  {
    id: "demandas_diversas", label: "Demandas diversas",
    entrega: [
      { id: "tramite_processos_SEI", 
        label: "Trâmite processos SEI",
        submission: "Processo SEI tramitado",
        complexity: "Baixo" 
      },
      { id: "enviar_emails", 
        label: "Enviar emails",
        submission: "Email enviado",
        complexity: "Baixo" 
      },
      { id: "elaborar_documentos_SEI", 
        label: "Elaborar documentos no SEI",
        submission: "Documento SEI elaborado",
        complexity: "Médio"  
      },
      { id: "colher_assinaturas", 
        label: "Coletar assinaturas para documentos SEI",
        submission: "Documento SEI assinado",
        complexity: "Baixo"  
      },

      { id: "reuniao_de_trabalho", 
        label: "Reunião de trabalho",
        submission: "Reunião realizada",
        complexity: "Baixo"  
      },
      { id: "alteracao_ipof_projeto", 
        label: "Alteração de IPOF em projeto",
        submission: "IPOF alterada em projeto",
        complexity: "Baixo"  
      },
      { id: "verificar_saldo_orcamentario", 
        label: "Verificar saldo orçamentário",
        submission: "Saldo orçamentário verificado",
        complexity: "Alto"  
      },
      { id: "emitir_parecer_em_projeto", 
        label: "Emitir parecer em projeto",
        submission: "Parecer em projeto emitido",
        complexity: "Baixo"  
      },
    ],
    tarefa: []
  },

  {
    id: "elaboracao_ploa", label: "Elaboração da PLOA",
    entrega: [
      { id: "elaborar_relatorios_ploa", 
        label: "Elaborar relatórios PLOA",
        submission: "relatório PLOA elaborado",
        complexity: "Médio"  
      },
      { id: "elaborar_planilha_revisao_renovacoes", 
        label: "Elaborar planilha revisão renovações",
        submission: "Planilha revisão renovações elaborada",
        complexity: "Médio"  
      },

      { id: "criacao_ipofs", 
        label: "Criação de IPOFs",
        submission: "IPOFs criadas",
        complexity: "Médio"  
      },

      { id: "revisar_proposta", 
        label: "Revisar proposta",
        submission: "PLOA revisada",
        complexity: "Alto"  
      },
      

      { id: "fechar_proposta", 
        label: "Fechar proposta",
        submission: "Proposta fechada",
        complexity: "Baixo"  

      },
    ],
    tarefa: []
  },

  {
    id: "controle_orcamentario", label: "Controle Orçamentário",
    entrega: [
      { id: "solicitar_credito_suplementar", 
        label: "Solicitar crédito suplementar",
        submission: "Crédito suplementar solicitado",
        complexity: "Alto"  
      },
      { id: "atualizar_orcamento", 
        label: "Atualizar orçamento",
        submission: "Orçamento atualizado",
        complexity: "Alto"  
      },
    ],
    tarefa: []
  },

  {
    id: "pagamentos", label: "Pagamentos",
    entrega: [
      { id: "fornecedores_regular", 
        label: "Fornecedores - regular",
        submission: "Fornecedor regular pago",
        complexity: "Médio"  
      },
      { id: "tributos_regular", 
        label: "Tributos - regular",
        submission: "Tributo regular pago",
        complexity: "Médio"  
      },

      { id: "fornecedores_complexo", 
        label: "Fornecedores - complexo",
        submission: "Fornecedor complexo pago",
        complexity: "Alto"  
      },
      { id: "tributos_complexo", 
        label: "Tributos - complexo",
        submission: "Tributo complexo pago",
        complexity: "Alto"  
      },

      { id: "diarias", 
        label: "Diárias",
        submission: "Diária paga",
        complexity: "Médio"  
      },
      { id: "fundo_rotativo", 
        label: "Fundo rotativo",
        submission: "Fundo rotativo pago",
        complexity: "Médio"  
      },
      { id: "contratos_de_gestao", 
        label: "Contratos de Gestão",
        submission: "Contrato de gestão pago",
        complexity: "Alto"  
      },
      { id: "folha", 
        label: "Folha",
        submission: "Folha paga",
        complexity: "Alto"  
      },
      { id: "erario", 
        label: "Erário",
        submission: "Erário pago",
        complexity: "Alto"  
      },
      { id: "rescisao_servidores", 
        label: "Rescisão servidores",
        submission: "Rescisão do(s) servidor(es) paga",
        complexity: "Alto"  
      },
      { id: "auxilio_funeral", 
        label: "Auxílio funeral",
        submission: "Auxílio funeral pago",
        complexity: "Médio"  
      },
    ],
    tarefa: [
      { id: "indicar_recurso", label: "Indicar recurso" },
      { id: "daof", label: "Elaborar DAOF" },
      { id: "pdf_ipof", label: "Elaborar PDF/IPOF" },
      { id: "ne_nota_de_empenho", label: "Emitir Nota de Empenho" },
      { id: "liquidar_despesa", label: "Liquidar despesa" },
      { id: "cmdf", label: "Elaborar CMDF" },
      { id: "op", label: "Emitir OP" },
    ]
  },

  {
    id: "relatorios", label: "Relatórios",
    entrega: [
      { id: "emitir_relatorio", 
        label: "Emissão de relatório",
        submission: "Relatório emitido",
        complexity: "Alto"  
      },
      { id: "atualizar_planilhas", 
        label: "Atualizar planilhas",
        submission: "Planilha atualizada",
        complexity: "Médio"  
      },
    ],
    tarefa: []
  }
])
export const weight_complexity_GEOF = reactive([
  {complexity: "Baixo", weight: 1},
  {complexity: "Médio", weight: 2},
  {complexity: "Alto", weight: 3}
])

export const processos_GEOF = reactive([
{id: 'demandas_diversas', label: 'Demandas diversas'},
{id: 'elaboracao_ploa', label: 'Elaboração da PLOA'},
{id: 'controle_orcamentario', label: 'Controle Orçamentário'},
{id: 'pagamentos', label: 'Pagamentos'},
{id: 'relatorios_gerenciais', label: 'Relatórios Gerenciais'},
])

export const demandas_GEOF = reactive([
    {id: 'enviar_receber_atribuir_SEI', label: 'Enviar/receber/atribuir processos SEI'},
    {id: 'enviar_emails', label: 'Enviar emails'},
    {id: 'elaborar_documentos_SEI', label: 'Elaborar documentos no SEI'},
    {id: 'colher_assinaturas', label: 'Colher assinaturas'},
])

export const elaboracao_PLOA_GEOF = reactive([
    {id: 'elaborar_proposta', label: 'Elaborar proposta'},
    {id: 'revisar_proposta', label: 'Revisar proposta'},
    {id: 'concluir_proposta', label: 'Concluir proposta'},
])

export const controle_orcamentario_GEOF = reactive([
    {id: 'controlar_orcamento', label: 'Controlar orçamento'},
    {id: 'solicitar_credito_suplementar', label: 'Solicitar crédito suplementar'},
    {id: 'atualizar_orcamento', label: 'Atualizar orçamento'},
])

export const pagamentos_GEOF = reactive([
    {id: 'fornecedores', label: 'Fornecedores'},
    {id: 'tributos', label: 'Tributos'},
    {id: 'diarias', label: 'Diárias'},
    {id: 'fundo_rotativo', label: 'Fundo rotativo'},
    {id: 'contratos_de_gestao', label: 'Contratos de Gestão'},
    {id: 'folha', label: 'Folha'},
    {id: 'erario', label: 'Erário'},
    {id: 'rescisao_servidores', label: 'Rescisão servidores'},
    {id: 'auxilio_funeral', label: 'Auxílio funeral'},
])

export const relatorios_gerenciais_GEOF = reactive([
    {id: 'emitir_relatorios', label:'Emitir relatórios'},
    {id: 'alimentar_planilhas_de_controle', label: 'Emitir planilhas de controle'},
])

export const tarefa_pagamentos = reactive([
    {id: 'indicar_recurso', label: 'Indicar recurso'},
    {id: 'daof', label: 'DAOF'},
    {id: 'pdf_ipof', label: 'PDF/IPOF'},
    {id: 'ne_nota_de_empenho', label: 'NE Nota de Empenho'},
    {id: 'liquidar_despesa', label: 'Liquidar despesa'},
    {id: 'cmdf', label: 'CMDF'},
    {id: 'op', label: 'OP'},
])

export function getLabel(id, options) {
  if (!id) return ''
  const opt = options.find(o => o.id === id)
  return opt ? opt.label : id
}

export const entrega_GEOF = reactive([
    {id: 'enviar_receber_atribuir_SEI', label: 'Enviar/receber/atribuir processos SEI'},
    {id: 'enviar_emails', label: 'Enviar emails'},
    {id: 'elaborar_documentos_SEI', label: 'Elaborar documentos no SEI'},
    {id: 'colher_assinaturas', label: 'Colher assinaturas'},
    {id: 'elaborar_proposta', label: 'Elaborar proposta'},
    {id: 'revisar_proposta', label: 'Revisar proposta'},
    {id: 'concluir_proposta', label: 'Concluir proposta'},
    {id: 'controlar_orcamento', label: 'Controlar orçamento'},
    {id: 'solicitar_credito_suplementar', label: 'Solicitar crédito suplementar'},
    {id: 'atualizar_orcamento', label: 'Atualizar orçamento'},
    {id: 'fornecedores', label: 'Fornecedores'},
    {id: 'tributos', label: 'Tributos'},
    {id: 'diarias', label: 'Diárias'},
    {id: 'fundo_rotativo', label: 'Fundo rotativo'},
    {id: 'contratos_de_gestao', label: 'Contratos de Gestão'},
    {id: 'folha', label: 'Folha'},
    {id: 'erario', label: 'Erário'},
    {id: 'rescisao_servidores', label: 'Rescisão servidores'},
    {id: 'auxilio_funeral', label: 'Auxílio funeral'},
    {id: 'emitir_relatorios', label:'Emitir relatórios'},
    {id: 'alimentar_planilhas_de_controle', label: 'Emitir planilhas de controle'},
])